<template>
<div class="animated fadeIn">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>Manage answers</h3>
      </div>
      <div class="col-md-4 m-auto">
        <button type="button" class="btn btn-delete ml-2" @click="deleteAll()">
          <!-- icon icon="plus"></icon --> {{$t('DELETEALLQUESTIONS')}}
        </button>
        <button type="button" class="btn btn-primary" @click="showModal()">
          <!-- icon icon="plus"></icon --> {{$t('ADDANSWER')}}
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('ANSWER')}}</th>
                <th>{{$t('ISCORRECT')}}</th>
                <th>{{$t('ACTION')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in response.root">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td>{{item.answer}}</td>
                  <td>{{(item.isCorrect) ? $t('YES') : $t('NO')}}</td>
                  <td>
                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showModal(item)">{{$t('EDIT')}}</button>
                    <button type="button" class="btn btn-delete btn-sm" @click="deleteRow(item.multyId)">{{$t('DELETE')}}</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('MANAGEANSWERSFORM')" ok-title="submit" hide-footer size='lg' no-close-on-backdrop>
    <div class="d-block">
      <multyform v-bind:formData="formData" v-bind:formError="formError"></multyform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/training/MultyQuizAnswers'
import MultyForm from './MultyForm'

export default
{
  name: 'ManageAnswers',
  components:
  {
    multyform: MultyForm
  },
  data: function()
  {
    return {
      response:
      {},
      formError:
      {},
      formData:
      {
        pageId: null,
        answer: '',
        isCorrect: 0
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectRow(
        {
          'pageId': me.$route.params.pageId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async deleteRow(id)
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await Api.deleteRow(
            {
              id: id
            });
            me.$notify.notice(data);
            await me.getData();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.multyId != 'undefined')
        {
          item.id = item.multyId;
          delete(item.multyId);
        }

        me.$set(item, 'pageId', me.$route.params.pageId);

        var data = await Api.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        pageId: null,
        answer: '',
        isCorrect: 0
      }
    },
    async deleteAll()
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await Api.deleteAll(
            {
              id: me.$route.params.pageId
            });
            me.$notify.notice(data);
            await me.getData();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    }
  },
  watch:
  {

  },
  computed:
  {

  }
}
</script>
